import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Loader } from 'react-feather';
var classes = {
    base: 'inline-flex items-center justify-center transform-gpu transition-colors gap-2',
    type: {
        primary: 'rounded-full bg-secondary-04 text-brand-color lg:hover:bg-hover-btn cursor-pointer',
        outlined: 'rounded-full bg-transparent text-brand-color border border-brand-01 cursor-pointer hover:bg-brand-01 hover:text-white dark:text-white dark:border-white dark:hover:bg-white dark:hover:text-brand-01',
        disabled: 'rounded-full bg-gray-300 text-gray-600 text-brand-color cursor-default pointer-events-none',
        inline: 'leading-[1.5rem] md:transition-opacity md:hover:opacity-60 md:group-hover:opacity-60',
    },
    alert: {
        danger: 'border-brand-02 text-brand-02 hover:text-brand-02-dark hover:border-brand-02-dark hover:bg-transparent',
    },
    size: {
        primary: {
            sm: 'text-sm px-4 leading-[2rem]',
            md: 'px-7 leading-[3rem]',
        },
        outlined: {
            sm: 'text-sm px-4 leading-[2rem]',
            md: 'px-7 leading-[3rem]',
        },
        disabled: {
            sm: 'text-sm px-4 leading-[2rem]',
            md: 'px-7 leading-[3rem]',
        },
        inline: {
            sm: 'text-sm leading-[2rem]',
            md: 'leading-[3rem]',
        },
    },
    reverse: 'flex-row-reverse',
};
var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'primary' : _b, _c = _a.side, side = _c === void 0 ? 'end' : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, icon = _a.icon, onClick = _a.onClick, to = _a.to, children = _a.children, className = _a.className, _e = _a.submit, submit = _e === void 0 ? false : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, alert = _a.alert, _g = _a.disabled, disabled = _g === void 0 ? false : _g;
    var Icon = icon;
    var handleClick = function () {
        if (!onClick)
            return;
        onClick();
    };
    return to ? (<Link to={to} className={classNames(classes.base, classes.type[type], classes.size[type][size], (disabled || loading) && classes.type.disabled, side === 'start' && classes.reverse, className)}>
      {children}
      {icon && <Icon size={18} className="flex-none"/>}
    </Link>) : (<button onClick={handleClick} className={classNames(classes.base, classes.type[type], classes.size[type][size], (disabled || loading) && classes.type.disabled, side === 'start' && classes.reverse, alert && classes.alert[alert], className)} type={submit ? 'submit' : 'button'}>
      {children}
      {icon && !loading && <Icon size={18} className="flex-none"/>}
      {loading && <Loader size={18} className="animate-spin-loader"/>}
    </button>);
};
export default Button;
